import React from "react";
import pulsewalker from "../../../assets/images/portfolio/project-pulsewalker-main.png";

export default function ProfessionalProjects() {
    return (
        <section id="proProjectsSMS" className="proProjects__container sms__container anchor ">
            <div className="projects__yellowFlourish"></div>
            {/* Projects List */}
            <div className="container">
                <div className="box row projects__row sms__row">
                    <div className="proProjects__textBox col-lg-7 col-md-12 col-sm-12 col-12 order-lg-1 order-md-2 order-sm-2 order-2">
                        <p className="proProjects__projectTitle">Saturday Morning Studio</p>
                        <p className="proProjects__description">I joined on a director level to build a new studio from the ground up, establishing core processes, pipelines, and team structure while scaling a cross-functional team of 15+ engineers and contributors. I partnered closely with the team to define execution standards and delivery practices from day one.</p>
                        <p className="proProjects__description">Here I designed and implemented end-to-end production workflows covering planning, development, QA, and live operations, enabling fast iteration and predictable delivery. In parallel, I mentored team members and expanded team capabilities to meet evolving technical and operational demands.</p>
                        <p className="proProjects__description">I led business development and external partnerships, pitching projects, aligning stakeholders, and translating market and performance data into clear product roadmaps with measurable KPIs. This ensured technical execution remained aligned with long-term business goals and sustainable growth.</p>
                        <div className="primary-button__container">
                            <div className="proProject__capsule capsule">Engineering Mgmt</div>
                            <div className="proProject__capsule capsule">Production</div>
                            <div className="proProject__capsule capsule">Project Mgmt</div>
                        </div>
                        <div className="primary-button__container">
                            <hr className="primary-button__line" />
                            <a
                                href="/projects"
                                rel="noreferrer"
                            >
                                <button className="primary-button">More Projects</button>
                            </a>
                        </div>
                    </div>
                    <div className="proProjects__project-container col-lg-7 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1">
                        <div className="sms__imageBlocks">
                            <img
                                src={pulsewalker}
                                className="proProjects__image proProjects__primary-image main__genvid__image"
                                alt="Proprietary Streaming Platform"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
